// extracted by mini-css-extract-plugin
export default {"container":"AvisoPrivacidad_container__sQsHh","titles":"AvisoPrivacidad_titles__CBomE"};